import config from '../../constants/config';
import { getCleanUsername } from '../helpers/utils';

export default {
  and: 'og',
  SignUp: 'Tilmeld dig',
  LogIn: 'Log på',
  LOGIN: 'LOG PÅ',
  Close: 'Afslut',
  Ok: 'OK',
  Back: 'Tilbage',
  He: 'He',
  She: 'Hun',
  Him: 'Ham',
  Her: 'Hende',
  Find: 'Find',
  Thanks: 'Tak',
  SingUpLanding: 'Tryk her for at finde',
  LogInLanding: 'Allerede medlem? Log ind her',
  TitleLanding: 'Træt af gamle dating sites?',
  SubTitleLanding:
    'Det er vi også! Oplev en ny oplevelse på ' +
    config.TITLE +
    ' med funktioner som disse:',
  logInWithApple: 'Login med Apple',
  mailIsConfirmed:
    'Tillykke! Din konto er blevet aktiveret med succes. Tak for at bekræfte din e-mail. Du kan nu nyde fuld adgang til vores tjenester.',
  SignUpWithEmail: 'Tilmeld dig med e-mail',
  reactivateAccount: 'Genaktiver konto',
  welcomeBack: 'Velkommen tilbage',
  prevYouDeactivYourAcc: 'Du deaktiverer din konto tidligere',
  doUwantToReacYourAcc: 'Vil du genaktivere din konto',
  yesReactivateMyAcc: 'Ja, Genaktiver min konto',
  noKeepDeactivated: 'Nej, hold det deaktiveret',
  signUpWithApple: 'Fortsæt med Apple',
  TermsOfService: 'Servicevilkår',
  PrivacyPolicy: 'Fortrolighedspolitik',
  JoinToday: 'Bliv medlem i dag',
  firstName: 'Fornavn',
  yourFirstName: 'Fortæl mig venligst dit fornavn',
  EmailAddress: 'E-mail-adresse',
  password: 'Adgangskode',
  EnterEmailAddress: 'Indtast e-mail-adresse',
  EnterPassword: 'Indtast adgangskode',
  PleaseEnterValidEmail: 'Indtast gyldig e-mail-adresse',
  PleaseEnterPassword: 'Indtast adgangskode',
  LandPageHeader: 'Klar til et nyt eventyr?',
  LandPageSubHeader:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) +
    ' Dating forbinder ' +
    config.NICHE_SINGULAR +
    ' singler på udkig efter romantik',
  LandPageLegal: 'Ved at logge ind accepterer du vores',
  LandPageAllDevices: 'Tilgængelig på alle enheder',
  ForgotYourPassword: 'Glemt din adgangskode?',
  or: 'eller',
  Save: 'Gem',
  views: 'Visninger',
  view: 'Visning',
  ViewedMyProfile: 'Set profil',
  ViewProfile: 'Se profil',
  UnmatchDelete: 'Afmærk/Slet',
  UnmatchDeleteQuestionMark: 'Afmærk/Slet?',
  UnmatchDeleteText:
    'Er du sikker på, at du vil afmærke/slette? Du har ikke længere adgang til din chathistorik med ',
  YesUnmatchDelete: 'JA, Afmærk/slet',
  IViewed: 'Jeg så',
  ViewedMe: 'Set mig',
  LikesMe: 'Synes godt om mig',
  Mutual: 'Gensidig',
  MyLikes: 'Mine likes',
  Chat: 'Chat',
  Flirts: 'Flirter',
  Send: 'Send',
  typing: 'skriver',
  UpgradeToVIP: 'Opgrader Til VIP',
  TypeAMessageHere: 'Skriv en besked her',
  FeaturesChat:
    config.NICHE_SINGULAR.replace(/\b\w/g, (c) => c.toUpperCase()) + ' Chat',
  SendMessagesToWhoYouWant: 'Send beskeder til hvem du vil',
  SeeWhoIsInterestedInYou: 'Se hvem der er interesseret i dig',
  SeeWhoIsReallyInterestedInYou: 'Se hvem der virkelig er interesseret i dig',
  IncreaseYourChancesWithAFlirt: 'Forøg dine chancer med en flirt',
  GetDatesFast: 'Hent dates hurtigt ved at sige ja eller nej',
  FeaturesIncluded: 'Funktioner inkluderet',
  Matches: 'Tændstikker',
  Likes: 'Synes godt om',
  QuickMatch: 'Hurtig kamp',
  Search: 'Søg',
  Favorite: 'Favorit',
  Favorites: 'Foretrukne',
  Browse: 'Gennemse',
  MyProfile: 'Min profil',
  Settings: 'Indstillinger',
  // Logout
  LogoutH1: 'Du er logget ud med succes',
  LogoutP: 'Du vil blive savnet...',
  LogoutButton: 'Log ind igen',
  // Unsubscribe
  tooManyEmails: 'For mange e-mails',
  enterYourEmailBelowToUnsub:
    'Indtast din e-mailadresse nedenfor for at afmelde dig',
  unsubscribe: 'Afmeld',
  unsubscribeSuccess: 'Afmelding lykkedes',
  youWillNoLongerReceiveAnyEmailFromUs:
    'Du modtager ikke længere nogen e-mails fra os ',
  unSubByAccident: 'Afmeldt på grund af en fejl',
  reSubHere: 'Tilmeld dig igen',
  helpUsGetBetter: 'Hjælp os med at blive bedre',
  tellUsWhyYouUnSub: 'Fortæl os, hvorfor du afmeldte',
  resubscribeSuccessful: 'Tilmeld dig igen',
  clickHere: 'Klik her',
  toGoBackToTheSite: 'at gå tilbage til siden',
  pleaseSelectOneOfTheReasonsBelow: 'Vælg en af ​​nedenstående grunde',
  notEnoughUsers: 'Ikke nok brugere',
  complicatedToUse: 'Kompliceret at bruge',
  notEnoughOptions: 'Ikke nok muligheder',
  betterAlternatives: 'Bedre alternativer',
  badExperienceWithAnotherUser: 'Dårlig oplevelse med en anden bruger',
  technicalIssues: 'Tekniske problemer',
  thanksForYourFeedback: 'Tak for din feedback',
  tapHere: 'Tryk her',
  // Who's online
  WhosOnline: 'Hvem er online',
  Recent: 'Seneste',
  ThisWeek: 'Denne uge',
  MembsWereOnlineRec: 'Medlemmer, der var online for nylig',
  MembsWereOnlineWeek: 'Medlemmer, der var online for nylig',
  MembsRecWillAppHere: 'Medlemmer, der for nylig er online, vises her',
  MembsThisWeekWillAppHere: 'Medlemmer, der er online denne uge, vises her',
  // Browse
  BrowseZero: 'Der er',
  BrowseZero2: 'Medlemmer',
  BrowseMembersAppear: 'Medlemmer vises her',
  // Favorites
  MyFavorites: 'Mine foretrukne',
  FavoritedMe: 'Foretrukket mig',
  YourFavWillAppHere: 'Dine favoritter vises her',
  MembHaveFavU: 'Medlemmer, der har foretrukket dig',
  MembWhoFavU: 'Medlemmer, der har foretrukket dig, vises her',
  NewPasswordSet: 'Ny adgangskode er klar. Nu kan du logge ind.',
  // Password Recovery
  recoveryTittle: 'Gendan adgangskode',
  recoveryButton: 'Gendan adgangskode',
  goBackToLogIn: 'Tilbage til log ind',
  recoveryMessage1:
    'Hvis vi finder en konto med den e-mail-adresse, vil gendannelsen af ​​adgangskoden blive sendt.',
  NewPassword: 'Ny adgangskode',
  SetNewPassword: 'Indstil ny adgangskode',
  // Info Line
  NotShared: 'Ikke delt',
  // Create Account Email Register
  byCreatingYourAccount:
    'Ved at tilmelde mig webstedet accepterer jeg vilkårene',
  alsoAgree:
    'Jeg accepterer også at modtage meddelelser, kontoopdateringer og særlige tilbud via e-mail',
  picturesDisclaimer:
    'Billeder bruges kun til illustrative formål, og enhver person, der er afbildet i indholdet, er en model',
  step: 'Trin',
  // GenderStep
  StepsTitle:
    'Kom Med Os & Mød ' +
    (config.NICHE_SINGLES
      ? config.NICHE_SINGLES
      : config.NICHE_PLURAL.replace(/\b\w/g, (c) => c.toUpperCase())) +
    ' Nu!',
  gender: 'Køn',
  startMeeting: 'Begynd at møde dem nu',
  weNeedInfo: 'Vi har brug for et par stykker info',
  iAm: 'Jeg er en:',
  near: 'Nær:',
  seeking: 'Leder du efter en:',
  next: 'Næste',
  viewOtherOptions: 'Se andre muligheder',
  // LocationStep
  location: 'Placering',
  WhereAreYouLocated: 'Hvor er du placeret?',
  WellFindMatchesInYourArea: 'Vi finder matches i dit område',
  EnterYourCityOrLocation: 'Indtast din by eller placering:',
  // AgeStep
  age: 'Alder',
  howOldAreYou: 'Hvor gammel er du?',
  enterAgeBelow: 'Indtast din alder nedenfor',
  ageLabel: 'Alder:',
  agePlaceholder: 'Din alder',
  ageError: 'Alder skal være mellem < og > ',
  EnterYourAge: 'Indtast din alder:',
  // UsernameStep
  username: 'Brugernavn',
  chooseUsername: 'Vælg et brugernavn',
  itWillBeYourBio: 'Det vil blive brugt på din profilbio',
  usernamePlaceholder: 'Eksempel: ' + getCleanUsername(config.NICHE_SINGULAR),
  chooseAUsername: 'Vælg et brugernavn',
  usernameError: 'Dette brugernavn er ikke gyldigt',
  usernameLabel: 'Brugernavn',
  usernameLabelSmall: '(6-14 bogstaver og tal)',
  // EmailStep
  emailPassword: 'E-mail/adgangskode',
  youAreDone: 'Du er næsten færdig...',
  createYourAccount: 'Opret din konto nedenfor',
  createAccount: 'Opret konto',
  emailError: 'Indtast venligst en gyldig e-mail-adresse',
  passwordError: 'Minimal adgangskodelængde er 6 tegn',
  ageMissingHeadline: 'Aldersanmodning',
  EnterYourEmailAddress: 'Indtast din e-mail',
  RemainsConfidential: '(forbliver fortrolig)',
  ChooseAPassword: 'Vælg en adgangskode',
  Min6Car: '(min. 6 tegn)',
  itWiilBeUsedForLogin: 'Det vil blive brugt til login',
  // PasswordStep
  choosePassword: 'Vælg adgangskode',
  // EmailAndPasswordStep
  enterEmailAndPassword: 'Indtast din e-mail og vælg adgangskode',
  // Auto-complete
  EnterYourLocation: 'Indtast din placering',
  EnterYourCityOrZipCode: 'Indtast din by eller postnummer nedenfor:',
  enterCityOrZip: 'Indtast din by eller postnummer:',
  Menu: 'Menu',
  More: 'Mere',
  // Matches
  noMatchesFound: 'Ingen matches fundet',
  wantMoreMatches: 'Vil du have flere kampe?',
  tapButtonBelow:
    'Tryk på knappen nedenfor for at ændre dine matchindstillinger',
  editMatchPreferences: 'Rediger match-præferencer',
  // MyLikes
  youHave: 'Du har',
  increaseYourMatches:
    'Forøg dine kampe ved at trykke på knappen "Kan lide" nedenfor',
  startLiking: 'Kan lide',
  // Mutual
  mutualLikes: 'Gensidige likes',
  // LikesMe
  membersHaveLikedYou: 'Medlemmer, der kan lide dig',
  // MyViews
  youHaveViewed: 'Du har set',
  profiles: 'Profiler',
  membersWhoYouViewed: 'Medlemmer, der har set dig, vises her',
  // ViewedMe
  memberViewedYou: 'Medlemmer, der har set dig',
  memberWhoViewYourProfile: 'Medlem, der ser din profil, vises her',
  // Settings
  logout: 'Log af',
  general: 'generelt',
  account: 'konto',
  legal: 'legal',
  support: 'support',
  matchPref: 'Matchindstillinger',
  emailPref: 'E-mail-indstillinger',
  privacyStgs: 'Privatlivsindstillinger',
  reactivateVipMbership: 'Genaktiver VIP-medlemskab',
  youAreVipMember: 'Du er et VIP-medlem',
  byCancelingYourVip:
    'Ved at opsige dit VIP-medlemskab har du ikke længere adgang til følgende funktioner, når din nuværende medlemsperiode udløber',
  unLimitedMessages: 'Ubegrænset antal beskeder',
  seeAllPhotos: 'Se alle fotos',
  unlimtedUndo: 'Ubegrænset fortrydelse \r',
  deactivateAccount: 'Deaktiver konto',
  deleteAccount: 'Slet konto',
  showMe: 'Vis mig',
  limitSearchToDistance: 'Begræns søgning til afstand',
  showAges: 'Vis aldre',
  men: 'Mænd',
  women: 'Kvinder',
  toastPrefUpdatedSucc: 'Indstillinger opdateret med succes',
  receiveEmail: 'Modtag e-mail',
  whenSomebodySendsNewMsg: 'Når nogen sender mig en ny besked',
  whenSomebodyLikesMe: 'Når nogen kan lide mig',
  whenSomebodyVisitMyPof: 'Når nogen besøger min profil',
  whenNewMembersComeOnline: 'Når nye medlemmer kommer online',
  withDiscountPromotions: 'Med rabatkampagner',
  whenSomebodyFlirtsMe: 'Når nogen flirter med mig',
  whenSomebodyAddsMeToFavorites: 'Når nogen tilføjer mig til favoritter',
  whenNearbyMembersComeOnline: 'Når medlemmer i nærheden kommer online',
  withNewWaysToMeetSingles: 'Med nye måder at møde singler på',
  whenMyFavoritesComeOnline: 'Når mine favoritter kommer online',
  whenNearbyMembersUploadPhoto: 'Når medlemmer i nærheden uploader et foto',
  whenSomebodyMatchesWithMe: 'Når nogen matcher med mig',
  whenSomebodyTriesToConnectWithMe:
    'Når nogen forsøger at forbinde sig med mig',
  notifEmailPauseFor30Days: 'Sæt alle e-mail-meddelelser på pause i 30 dage',
  notifEmailPausedUntil: 'E-mail-meddelelser sat på pause indtil',
  notifOptions: 'Notifikationsmuligheder',
  notifUpdateSucc: 'Meddelelser opdateret med succes',
  privacySettingsText1: 'Kontroller, hvem der ser din profil',
  privacySettingsText2: 'Vælg en eller flere muligheder nedenfor',
  importantNotice: 'Vigtig meddelelse',
  byDeactivatingYourAccount:
    'Ved at deaktivere din konto har du ikke adgang til følgende, indtil du genaktiverer din konto',
  yourMatches: 'Dine kampe',
  yourMessages: 'Dine meddelelser',
  yourLikes: 'Dine likes',
  yourFavorites: 'Dine favoritter',
  allOtherInfo: 'Alle andre oplysninger, der er knyttet til din konto',
  yourProfileWillBeHidden:
    'Din profil vil blive skjult for andre medlemmer. Du modtager ikke e-mails fra os, før du genaktiverer din konto. Tryk på knappen nedenfor for at deaktivere din konto',
  areYouSure: 'Er du sikker',
  yourAccountWillBeDeact: 'Din konto deaktiveres',
  yesDeactivateAcc: 'Ja, deaktiver konto',
  accountSuccDeact: 'Konto blev deaktiveret',
  byDeletingYourAccount:
    'Ved at slette din konto slettes følgende oplysninger permanent',
  infoUsedToCreate: 'Oplysninger, der bruges til at oprette din konto',
  yourPhotos: 'Dine fotos',
  yourChatHistory: 'Din chathistorik',
  thisActionIsNotReversible: 'Denne handling er ikke reversibel',
  tapTheButtonBellow: 'Tryk på knappen nedenfor for at slette din konto',
  yesDeleteAccount: 'Ja, slet konto',
  accountSuccDelete: 'Konto blev slettet',
  byReactivatingYourVip:
    'Ved at genaktivere dit VIP-medlemskabsabonnement vil du blive faktureret i slutningen af den aktuelle faktureringsperiode',
  tapTheButtonToReactivateVip:
    'Tryk på knappen nedenfor for at genaktivere dit VIP-medlemskab',
  yourMembershipWillExpire: 'Dit medlemskab udløber den',
  yourMembershpWillRenew: 'Dit medlemskab fornyes den',
  yourVipMembershipWillReactivate: 'Dit VIP-medlemskab genaktiveres',
  yesReactivateVip: 'Ja, Genaktiver VIP-medlemskab',
  noIveChangedMyMind: 'Nej, jeg har skiftet mening',
  membershipSuccessfullyReactivated: 'Membership Geneactivated',
  membershipSuccessfullyCanceled: 'Medlemskab blev annulleret',
  visibilityPreferences: 'Synlighedsindstillinger',
  onlyShowMyProfileToPeopleISendMsg:
    'Vis kun min profil til personer, som jeg sender en besked til',
  dataManagement: 'Datastyring',
  tapTheDownloadDataButtonBelowToViewYourAccountData:
    'Tryk på knappen "Eksportér data" nedenfor for at se dine kontodata',
  downloadData: 'Eksportér data',
  yesDownload: 'Ja, download',
  yourDataWillBeDownloaded: 'Dine data downloades',
  changePassword: 'Skift adgangskode',
  saveChanges: 'Gem ændringer',
  currentPassword: 'Nuværende kodeord',
  confirmNewPassword: 'Bekræft ny adgangskode',
  enterNewPassword: 'Indtast ny adgangskode',
  passwordNotMatch: 'Adgangskoden passer ikke',
  passwordChangedSuccess: 'Adgangskode ændret med succes',
  registredAs: 'Registreret som:',
  userID: 'Bruger ID:',
  version: 'Version:',
  // Member
  cancel: 'Annuller',
  reportUser: 'Rapporter bruger',
  blockUser: 'Bloker bruger',
  options: 'Valgmuligheder',
  startConversation: 'Start en samtale',
  requestPhotoTap: 'Tap Here',
  requestPhotoTapTo: 'at anmode om sit foto',
  requestPhotoTapToFemale: 'at anmode om hendes foto',
  requestPhoto: 'at anmode om foto',
  photoAlreadyRequested: 'Foto allerede anmodet',
  youAlreadyRequestedPhoto: 'Du har allerede anmodet om brugerens foto',
  photoRequestSuccessfully: 'Fotoanmodning blev gennemført',
  tellWhy: 'Fortæl os hvorfor',
  inappropriatePhotos: 'Upassende fotos',
  inappropriateMessages: 'Upassende meddelelser',
  badOfflineBehavior: 'Dårlig offlineadfærd',
  feelsLikeSpam: 'Ser ud som spam-post',
  other: 'Andet',
  report: 'Rapport',
  reportComment: 'Rapporter kommentar ...',
  blockMember: 'Bloker medlem?',
  willNoLongerAppear: 'vises ikke længere på din liste over kampe.',
  yesBlock: 'Ja, bloker medlem',
  noCancel: 'Nej, annuller',
  userReportedSuccessfully: 'Bruger rapporteret med succes',
  userBlockedSuccessfully: 'Bruger blokeret med succes',
  addedToFavorites: 'Tilføjet til favoritter!',
  removedFromFavorites: 'Fjernet fra favoritter!',
  sendAMessage: 'Send en besked',
  sendUserAMessage: 'Send {user} en besked',
  wellYouveComeThisFar:
    'Nå, du er kommet så langt, kan lige så godt sige noget',
  chatWith: 'Chat med',
  outOfFlirts: 'Ikke flere flirter',
  untilYouCanSend: 'Indtil du kan sende en flirt igen.',
  wantToMakeSure: 'Vil du være sikker',
  seesYou: 'ser dig?',
  goVipGetFlirts: 'Gå VIP og få {num_of_flirts} flirt om dage!',
  getMoreFlirts: 'Få flere flirter',
  noNotThisTime: 'Nej, ikke på dette tidspunkt',
  flirtSent: 'Flirt sendt',
  memberNotSharedAboutMe: 'Dette medlem har ikke delt deres om mig info ',
  dontWait: 'Vent ikke',
  chooseFlirt: 'Vælg en flirt:',
  sendFlirt: 'Send en flirt',
  flirtIsSent: 'Flirt sendes',
  // Chats
  chats: 'Chats',
  sentMessages: 'Sendte Beskeder',
  yourConversations: 'Dine samtaler med andre medlemmer vises her',
  yourSentMessages: 'Dine sendte beskeder til andre medlemmer vises her',
  // ChatRoom
  cannotSendMessageUnlessVip:
    "Du kan ikke sende chatbeskeder, medmindre du er VIP-bruger eller 'Happy Hour' er aktiv",
  happyHour: 'Happy Hour',
  sendMessagesFree: 'Send beskeder gratis',
  endsIn: 'Slutter i:',
  happyHourTonightAt: 'I aften kl.',
  happyHourTodayAt: 'I dag kl.',
  // Contact us
  ContactUs: 'Kontakt os',
  ContactUsSupport: 'Kontakt os / support',
  WhatIsYourEmail: 'Hvad er din e-mail-adresse?',
  HowCanWeHelpU: 'Hvordan kan vi hjælpe dig?',
  WriteMsg: 'Skriv besked ...',
  SendMsg: 'Send besked',
  EnterMsg: 'Indtast besked.',
  AlertMsgSentSuccessfully: 'Tak! Meddelelsen blev sendt. ',
  ToastMsgSentSuccessfully: 'Besked sendt med succes',
  Subject: 'Emne',
  subject0: 'Generelle problemer',
  subject1: 'VIP-medlemskab',
  subject2: 'Rapport om svig',
  subject3: 'Annullering',
  subject4: 'Slet konto',
  subject5: 'Andet',
  // Search
  refineSearch: 'Juster søgning',
  iamDoneRefining: 'Jeg er færdig med raffinering',
  showAdvanced: 'Vis avancerede indstillinger',
  hideAdvanced: 'Skjul avancerede indstillinger',
  cancelSearch: 'Annuller raffinering',
  youWillLoseYourChanges: 'Du mister alle ændringer i dine søgekriterier',
  yesLeavePage: 'Ja, forlad side',
  noContinueRefining: 'Nej, fortsæt raffinering',
  zeroMembersFound: 'Medlemmer fundet',
  tap: 'Tryk',
  // tapHere: 'Tap Here',
  // uploadAPhotoHere: 'Upload a photo here',
  toDisplayPreviousMembers: 'for at vise tidligere medlemmer.',
  toEditCurrentFilters: 'for at redigere dine aktuelle filtre.',
  resetSearch: 'Nulstil søgning',
  tryAgain: 'Prøv igen',
  mile: 'Mil',
  miles: 'Mile',
  noUsers: 'Ingen brugere',
  // Quick Match Button text
  undo: 'Fortryde',
  pass: 'Nej, tak',
  like: 'Ja, tak',
  profile: 'Profil',
  undoNotAvailable: 'Fortryd ikke tilgængelig',
  nothingToUndo: 'Der er intet at fortryde.',
  thisIsTheFirstUser: 'Dette er den første bruger.',
  dismissAd: 'Afvis',
  seeMoreHere: 'Se mere her',
  tryChangingYourPreferences: 'Prøv at ændre dine præferencer.',
  errorOnInviteActionTitle: 'Fejl ved hurtig match',
  // It's Match
  itsMutual: 'Det er gensidigt',
  youAndMemberLikeEachOther: 'Du og {member} kan lide hinanden!',
  seeMoreMatches: 'Se flere kampe',
  // My Profile
  edit: 'Rediger',
  aboutMe: 'Om mig',
  youHaveNotSharedAbout: 'Du har ikke delt dine Info om mig endnu',
  appearance: 'Udseende',
  situation: 'Situation',
  addPhoto: 'Tilføj profilbillede',
  // Edit Profile
  editProfile: 'Rediger profil ',
  reset: 'Nulstil',
  dob: 'Fødselsdato',
  youWillLoseYourChangesProfile:
    'Du mister alle de aktuelle ændringer, du har foretaget i din profil',
  cancelEdit: 'Annuller redigering af din profil?',
  noContinueEditing: 'Nej, fortsæt redigering',
  invalidMonth: 'Ugyldig måned',
  invalidDay: 'Ugyldig dag',
  invalidAge: 'Du skal være mellem {min} og {max} år',
  invalidFebruar: 'Februar kan maksimalt have 28 eller 29 dage',
  invalid30Day: 'Denne måned kan maksimalt have 30 dage',
  invalid31Day: 'Denne måned kan maksimalt have 31 dage',
  invalidLocation:
    'Placering er ugyldig, vælg venligst placering fra rullelisten',
  locationUpdated: 'Placering blev opdateret',
  setAsMainPhoto: 'Angiv som hovedfoto',
  changeAsMainPhoto: 'Skift som hovedfoto',
  deletePhoto: 'Slet foto',
  areSureDeletePhoto: 'Er du sikker på, at du vil slette dette billede?',
  noKeepPhoto: 'Nej, hold billede',
  yesDeletePhoto: 'Ja, slet foto',
  editPhoto: 'Rediger foto',
  profileUpdated: 'Profil opdateret med succes',
  secondaryImageAlertText:
    'Dette billede er mærket som sekundært af kundesupport, og som sådan kan det ikke indstilles som profilbillede.',
  reviewImageAlertText:
    'Dette billede er ikke godkendt endnu af vores kundesupport, prøv senere.',
  pendingReview: 'Afventer gennemgang',
  // missing location
  locationReq: 'Placeringsanmodning',
  pleaseEnterLocation: 'Indtast din placering nedenfor.',
  withoutItOther: 'Uden det, andre medlemmer',
  cantSee: 'kan ikke se,',
  likeOrMessage: 'synes godt om dig eller sendte en besked til dig.',
  submit: 'Indsend',
  // missing username
  completeYourProfile: 'Fuldfør din profil',
  itWillBeUsedOnYourProfileBio: 'Det vil blive brugt på din profilbio',
  userNameLettersAndNumbers: '(6-14 bogstaver og tal)',
  submitUsername: 'Indsend brugernavn',
  unknownError: 'Ukendt fejl opstod',
  confirmUsername: 'Vælg et brugernavn',
  orChooseNewOne: 'eller vælg en ny.',
  // missing username and location
  welcomeToSite: 'Velkommen til ' + config.TITLE,
  yourAccountIsNowActive: 'Din konto er nu aktiv!',
  itsGreatToHaveYou:
    'Det er dejligt at have dig her som medlem, og vi her og ser frem til at hjælpe dig med at finde det perfekte match.',
  // error
  somethingWentWrong: 'Noget gik galt',
  networkError: 'Netværksfejl',
  // invalid Token
  invalidToken: 'Ugyldig token. Log ind igen ',
  // afvist brugernavn
  rejectedUsername: 'Afvist brugernavn',
  // missing password
  missingPassword: 'Du er næsten færdig ...',
  missingPasswordText: 'Indstil din adgangskode nedenfor',
  missingPasswordPlaceholder: 'minimum 6 tegn',
  submitPassword: 'Indstil adgangskode',
  // missing email
  missingEmail: 'Vi mangler din e-mail',
  missingEmailText:
    'Indtast din e-mail-adresse nedenfor for underretninger, når du modtager nye beskeder, likes, matches og personer, der ser din profil.',
  submitEmail: 'Indsend e-mail',
  // Move and Scale
  moveAndScale: 'Flyt og skaler',
  crop: 'Beskær',
  uploadError: 'Fejl ved upload af billede',
  whoops: 'Hov',
  itSeemsThatIsTaking:
    'Det ser ud til, at det tager længere tid end normalt at uploade et foto. Prøv igen.',
  // Missing Photo
  photoRequest: 'Fotoanmodning',
  wait: 'Vent ...',
  yourMissingPhoto: 'Du mangler et foto',
  membersWithoutPhotos: 'Medlemmer uden fotos har 65% mindre',
  likelyToReceive: 'chancer for at modtage likes og beskeder',
  submitPhoto: 'Send billede',
  takePhoto: 'Tag foto',
  chooseFromLibrary: 'Vælg fra fotobibliotek',
  // Missing Gender
  youLookingFor: 'Hvad leder du efter',
  // Explicit Opt in Modal
  youAreAlmostDone: 'Du er næsten færdig',
  iWouldLikeToGetSpecOffers:
    'Jeg vil gerne have specielle tilbud, skøre rabatter og månedligt salg via e-mail',
  iHaveReadAndAgreeToPP: 'Jeg har læst og accepterer vilkårene for',
  ByJoiningTheSiteAgreeTos: 'Ved at tilmelde mig webstedet accepterer jeg',
  optional: 'Valgfrit',
  required: 'Påkrævet',
  continue: 'Fortsæt',
  // coreg
  toGetStarted: 'At komme i gang',
  tapHereToGetStarted: 'Tryk her for at komme i gang',
  hello: 'hej',
  // Upgrade Modal
  membershipStatus: 'Medlemsstatus',
  upgradeToVipChoosePlan: 'Opgrader til VIP.',
  wantUnlimitedMessages: 'Vil du have ubegrænsede meddelelser?',
  wantToReply: 'Vil du svare på% gender%? Gå VIP! ',
  getUnlimitedMessages: 'Få ubegrænsede meddelelser. Vælg en plan: ',
  needToUndoMistake: 'Har du brug for at fortryde en fejl? Gå VIP! ',
  getUnlimitedUndos: 'Få ubegrænset fortryd - Vælg en plan: ',
  whoViewedYourProfile: 'Hvem har set din profil? Finde ud af!',
  peopleViewedYourProfile: 'Folk så din profil',
  chooseVipPlanToSeeThem: 'Vælg en VIP-plan og se dem:',
  wantToSeeWhoFavoritedYou: 'Vil du se, hvem der har foretrukket dig?',
  peopleFavoritedYou: 'Folk, der har foretrukket dig',
  wantToSeeWhoLikesYou: 'Vil du se, hvem der kan lide dig?',
  peopleLikedYou: 'Folk kunne lide dig',
  youAreBasic: 'Du er et grundlæggende medlem',
  wantToUnlockPhotos: 'Vil du låse op for alle fotos?',
  wantMoreFlirts: 'Vil du have 5 flirter om dagen?',
  vipMembershipFeatures: 'VIP Premium-medlemsfunktioner inkluderer:',
  vipMembershipFeaturesMobile: 'VIP-medlemmer modtager:',
  unlimited: 'Ubegrænset',
  messaging: 'Beskeder',
  meetSomeoneTonight: 'Opgrader nu - Mød nogen i aften!',
  chooseVipPlanBelow: 'Vælg en VIP-plan nedenfor:',
  messagingSub: 'Fortsæt chats med dine matches',
  viewedSub: 'Se hvem der har set din profil',
  likesMeSub: 'Find ud af, hvem der kunne lide din profil',
  unlockPhotosSub: 'Se alle brugernes fotos',
  favoritedMeSub: 'Se hvem der virkelig er interesseret i dig',
  moreFlirtsSub: 'Forøg dine chancer med 5 flirt om dagen',
  goPrivateSub: 'Kontroller, hvem der ser din profil',
  undoSub: 'Lavet en fejl? Fortryd din strygning! ',
  select: 'Vælg',
  vipMembersReceive: 'VIP MEDLEMMER MODTAGER:',
  chooseYourPlan: 'VÆLG DIN PLAN:',
  enterPaymentDetails: 'ANGIV DINE BETALINGSDETALJER:',
  creditCard: 'Kreditkort',
  yourSubscriptionWillRebill:
    'Dit abonnement genoprettes automatisk til et {0} medlemskab kl. {1} den {2} og forny hver {0} indtil det opsiges. Du kan når som helst annullere via dine kontoindstillinger.',
  byTappingButtonBelow: 'Ved at trykke på knappen nedenfor accepterer du',
  andAuthorizeToCharge:
    'og tillad os at opkræve din %CARD_TYPE% nu og ved hver fornyelse',
  continueToPayPal: 'Fortsæt til PayPal for at gennemføre dit køb.',
  proceedToPayPal: 'Fortsæt til PayPal',
  limitedTimeOffer: 'Begrænset tilbud',
  promoHeader: '{date} VIP-medlemsforsøg til {price}',
  promoHeaderNoTrial: '{price} / {rebill_period} måned(er)',
  promoSubHeaderText: 'Dette er et eksklusivt engangstilbud for nye medlemmer',
  promoButtonText: 'Kun {price} -{date} prøveperiode',
  promoRebillsText:
    '* Gefaktureres hver {date} for {price}, hvis VIP-medlemskab ikke annulleres inden afslutningen af ​​prøveperioden *',
  accessToAllPhotos: 'Adgang til alle fotos er tilgængelig',
  toPremiumUsers: 'kun til premium-brugere.',
  unlimitedMessaging: 'Ubegrænset antal besked er tilgængelig',
  upgradeTodayAndSendMessage:
    'Opgrader i dag for at læse og besvare beskeder fra',
  upgradeTodayAndSeePhotos: 'Opgrader i dag for at få adgang til alle fotos af',
  mostPopular: 'Mest populære',
  notSuitableForCreditCard: 'Ikke egnet til betaling med kreditkort?',
  weAreAccepting: 'Vi accepterer',
  payPal: 'PayPal',
  // Welcome Back Modal
  weHaveAnOffer: 'Vi har et tilbud til dig:',
  discount: 'rabat',
  onVipMembership: 'på et VIP-medlemskab!',
  tapHereToSave: 'Tryk her for at spare 50%!',
  toUnlockFeatures: 'for at låse op for alle premium-funktioner',
  upgrade: 'Opgrader',
  upgradeNow: 'Opgrader nu',
  // Invalid Tagline
  invalidTaglineHeadline: 'Beskrivelse afvist',
  invalidTaglineTitle: 'Teksten i sektionen "Om mig" blev ikke godkendt.',
  invalidTaglineReason: 'Grund:',
  invalidTaglineButton: 'Opdater beskrivelse',
  // Invalid Tagline
  photoRejectedHeadline: 'Foto afvist',
  photoRejectedTitle: 'Vi beklager ...',
  photoRejectedParagraph:
    'Et eller flere af dine uploadede fotos blev ikke godkendt.',
  photoRejectedReason: 'Grund:',
  photoRejectedButton: 'Send nyt billede',
  viewed: 'Set',
  myProfile: 'Min profil',
  unlock: 'Lås op',
  allPhotos: 'Alle fotos',
  undos: 'Fortryd',
  moreFlirts: 'Flere flirter ',
  goPrivate: 'Gå privat',
  monthFor: 'Måned',
  monthsFor: 'Måneder',
  mo: 'mo',
  month: 'måned',
  months: 'måneder',
  monthly: 'månedligt',
  billed: 'faktureret',
  every: 'hver',
  saveUpTo: 'Spar op til',
  trialFor: 'Prøveperiode til',
  day: 'dag',
  days: 'Dage',
  free: 'gratis',
  trialRebillsAt: 'trial rebills at',
  per: 'per',
  best: 'Bedste',
  value: 'Værdi',
  // Checkout
  planSelected: 'Plan valgt',
  paymentOption: 'Betalingsmulighed',
  billingDetails: 'Faktureringsoplysninger',
  payByCard: 'Betal med kort',
  creditOrDebitCard: 'Betal med kredit- eller betalingskort',
  payWith: 'Betal med',
  pay: 'Betal',
  pal: 'Pal',
  for: 'for',
  promoRebillsAt: 'promo genfaktureres den',
  chooseMembershipPlan: 'Vælg din medlemsplan nedenfor',
  choosePaymentOption: 'Vælg din betalingsmulighed nedenfor',
  enterCardDetails: 'Indtast dine kortoplysninger nedenfor',
  nameOnCard: 'Navn på kort',
  enterFullName: 'Indtast det fulde navn her',
  creditCardNumber: 'Kreditkortnummer',
  cardNumber: 'Kortnummer',
  expirationdate: 'Udløbsdato',
  cvv: 'CVV/Sikkerhed',
  pleaseEnterCvv: 'Indtast venligst CVV',
  forYourPrivacyYouAreBilled:
    'Af hensyn til dit privatliv faktureres du diskret som',
  byCompletingThisTransaction:
    'Ved at gennemføre denne transaktion bekræfter du, at du er mindst 18 år gammel, og at du accepterer at',
  submitAndUpgrade: 'Send og opgrader til VIP',
  thisIsSecurePage: 'Dette er en sikker side.',
  dataTransferIsEncrypted:
    'Dataoverførsel er krypteret for sikkerhed og beskyttelse',
  tellUsYourFullName: 'Fortæl os dit fulde navn som på kortet',
  andManyOthers: 'og mange andre',
  pleaseEnterYourCreditCard: 'Indtast dit kreditkortnummer',
  pleaseEnterValidCreditCard: 'Indtast gyldigt kreditkortnummer',
  pleaseEnterMonth: 'Indtast måned',
  pleaseEnterValidMonth: 'Indtast gyldig måned',
  pleaseEnterYear: 'Indtast år',
  pleaseEnterValidCvv: 'Indtast gyldig CVV',
  pleaseAgreeToTos: 'Please agree to the Terms of Service',
  thanksForBeingVip: 'Tak for at være VIP-medlem',
  subscriptionUnavailable:
    'Abonnement ikke tilgængeligt, fordi du allerede er VIP',
  onTheBackOfCard: 'På bagsiden af dit kort kan du',
  findYour: 'finde dit',
  cvvCvc: 'CVV/CVC',
  codeHere: 'kode here.',
  hurryUp: 'Skynd dig!',
  thisOfferExpires: 'Dette tilbud udløber om:',
  youAreInLuck: 'Du har held og lykke!',
  thisPromoGotExtended:
    'Denne promo blev udvidet. Grib det hurtigt, da vi muligvis tager dette tilbud ned når som helst nu. ',
  forYour: 'For din',
  privacy: 'privatliv',
  youAreBilled: 'du faktureres som',
  discreetly: 'diskret',
  as: 'som',
  specialOffer: 'Special tilbud',
  membershipInfo: 'Medlemsoplysninger',
  // Success Upgrade
  successUpgrade: 'Opgraderet med succes',
  welcomeToVip: 'Velkommen til VIP!',
  youHaveSuccessfullyUpgraded: 'Du er vellykket opgraderet til en',
  vipPremiumMembership: 'VIP Premium medlemskab',
  importantInfo: 'Vigtig information!',
  pleasePrintThisPage:
    'Udskriv denne side, eller skriv følgende oplysninger ned. Du får brug for dette i fremtiden for at få adgang til eller ændre dine medlemsoplysninger.',
  yourCreditCardBilled: 'Dit kredit- / betalingskort faktureres diskret som',
  yourPayPalCardBilled: 'Din PayPal-konto faktureres diskret som',
  youWillBeDicreetlyBilled: 'Du vil blive diskret faktureret som:',
  membershipPurchased: 'Købt medlemskab:',
  billingTerms: 'Faktureringsbetingelser:',
  vipPremium: 'VIP Premium',
  total: 'I alt',
  vip: 'VIP',
  trial: 'prøve',
  yourInfo: 'Din information:',
  fullName: 'Fuldt navn:',
  pleaseContactSupport: 'Kontakt support hvis du har spørgsmål om fakturering',
  billingSupport: 'Faktureringssupport:',
  billingPhone: 'Faktureringstelefon:',
  clickToAccessVip: 'Tap for at få adgang til VIP-funktioner',
  tapToAccessVip: 'Tap for at få adgang til VIP-funktioner',
  thirtyDays: '30 dage',
  // Process Payment
  processPayment: 'Vent venligst, vi behandler din betaling ...',
  paymentProcessingError: 'Betalingsbehandlingsfejl!',
  // Error Component
  serviceUnavailable: 'Tjeneste midlertidig utilgængelig',
  pleaseTryLater: 'Prøv senere',
  // Another Client
  isOpenInAnotherWindow:
    'er åben i et andet vindue. Du kan lukke dette vindue. ',
  useInThisWindow: 'Brug i dette vindue',
  // modal alert merging
  greatNews: 'Store nyheder',
  weAreHappy: 'Vi er glade for at kunne meddele, at det, effektivt i dag',
  become:
    '{old_site} og {new_site} er blevet et samlet stort websted: {new_site}! ',
  thisMeans:
    'Dette betyder et større samfund for alle vores medlemmer, flere kampe og en større chance for at finde nogen speciel.',
  dontWorry:
    'Bare rolig, intet ændret sig for vores medlemmer. Spis loginoplysninger, profiloplysninger og din historie er automatisk opdateret, så du kan fortsætte din søgning. ',
  // ads
  ad: 'Ad',
  sponsored: 'SPONSORERET',
  findNiche:
    'Find ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  meetNiche: 'Mød ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  // ads random text, this is generated like this for easy transition to another niche
  adsRandomTextMeetNiche:
    'Mød ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextSingleNiche:
    'Single ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextFindNiche:
    'Find ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextDateNiche:
    'Date ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheRomance:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Romantik',
  adsRandomTextLonelyNiche:
    'Ensom ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheLove:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Kærlighed',
  adsRandomTextWhantNiche:
    'Ønsker ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) + '?',
  adsRandomTextNicheDates:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Dates',
  adsRandomTextMoreNiche:
    'Mere ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextSearchNiche:
    'Søg ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheNow:
    config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) + ' Nu?',
  adsRandomTextNichesingles:
    config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) + ' Singler',
  // niche gender names
  genderTsTvTg: 'TS/TV/TG',
  genderXdresser: 'Crossdresser',
  genderCouple: 'Par',
  genderDom: 'Domme',
  genderFem: 'Femdom',
  genderBiCouple: 'Bi -par',
  genderSugarMale: 'Sugar baby mand',
  genderSugarBaby: 'Sugar Baby',
  genderHotWife: 'Hot kone ',
  genderMan: 'Mand',
  lookingFor: 'leder efter en',
  genderMilf: 'MILF',
  // onboarding
  moreInformation:
    'lad os få lidt mere information om dig, så vi kan finde andre singler, der matcher dig',
  howTallAreYou: 'Hvor høj er du?',
  UseSliderHeight: 'Brug skyderen til at angive din højde',
  WhatIsYourEthnicity: 'Hvad er din etnicitet?',
  specifyYourBodyType: 'Angiv venligst din kropstype',
  whatYouLookingFor: 'Fortæl os om dit perfekte match',
  idealMatchesAge: 'Hvad er din ideelle match alder',
  howFarAway:
    'Hvor langt væk ville du være villig til at rejse for at møde dit perfekte match?',
  useSliderDistance: 'Brug skyderen til at angive afstanden',
  toHaveYourProfile: 'Fortæl andre medlemmer om dig selv ...',
  writeSomethingAboutYourself:
    'Skriv noget interessant om dig selv, noget der beskriver dig bedst',
  uploadAPhoto: 'Upload et foto',
  thisIsImportant: 'Dette er det vigtigste!',
  youOnlyHave: 'Du har kun 1 chance for at efterlade det første indtryk',
  tipPhoto:
    'Tip: Billeder skal tages for nylig og kun omfatte dig og fremhæve dine bedste kvaliteter for de bedste resultater!',
  iUploadLater: 'Jeg uploader et foto senere ...',
  congratulations: 'Tillyke...',
  yourProfileUpdated:
    'Din profil er blevet opdateret, og du er et skridt tættere på at finde din perfekte match.',
  specialOfferNewMembers:
    'Som et særtilbud for nye medlemmer giver vi dig 25% rabat på vores faste medlemspriser.',
  get25OffNow: 'Få 25% rabat nu!',
  youWillBeRedirected: 'du bliver omdirigeret til at opgradere siden i',
  seconds: 'sekunder',
  aNewMember: 'Som nyt medlem kvalificerer du dig til et',
  get: 'Få',
  initialOff: '25% rabat ',
  selectedMembership: 'dit valgte medlemskab',
  selectYourMembership: 'Vælg din medlemsmulighed',
  newPrice: 'Ny pris',
  oldPrice: 'Gammel pris',
  iDontWantToPayLess: 'Nej tak, jeg vil ikke betale mindre.',
  addPhotoOnboarding: 'Tilføj billede',
  uploadAnotherPhoto: 'Upload et andet billede',
  finish: 'Afslut',
  ifYourDoneUploadingPhotos: 'Hvis du er færdig med at uploade fotos',
  // california
  CCPATitle: 'Sælg ikke mine personlige oplysninger',
  CCPAPersonal: 'Mine personlige oplysninger',
  youHaveAlreadyOptedOut: 'Du har allerede fravalgt.',
  // TransactionProgress
  transactionProgress: 'Transaktionsfremskridt',
  checkingSpecialOffers: 'Kontrol af specielle tilbud ...',
  initializingTransaction: 'Initialiserer transaktion ...',
  // SpecialOffer
  congratulationsSpecialOffer: 'Tillykke!',
  youAreQualified: 'Du er kvalificeret til et særtilbud!',
  toAcceptThisOffer: 'For at acceptere dette tilbud, tryk på Fortsæt nedenfor:',
  noThanksIDontWant: 'Nej tak, jeg vil ikke betale mindre.',
  forYourConvenience: 'For din bekvemmelighed bliver du genopfyldt',
  on: 'på',
  andEvery: 'og hver',
  daysThereafter: 'dage derefter, medmindre det annulleres.',
  off: 'af',
  yourSelectedMembership: 'dit valgte medlemskab.',
  // Transaction Declined
  transactionDeclined: 'Transaktion afvist',
  yourCreditCardWasNotApproved:
    'Dit kreditkort blev ikke godkendt til vores særlige medlemstilbud.',
  butWait: 'men vent ... her er et ekstra tilbud',
  tryA: 'Prøv en',
  forOnly: 'for kun',
  acceptOffer: 'Accepter tilbud',
  membership: 'Medlemskab',
  // Measure System
  measureSystem: 'Målesystem',
  imperial: 'Imperial',
  metric: 'Metrisk',
  // kink cam banner
  viewNow: 'Se nu',
  youGotAFree: 'Du har en gratis',
  // receipt page
  bonusMembership: 'Bonus medlemskab',
  membersLoginArea: 'Medlem login-område',
  // language
  language: 'Sprog',
  // OneClick
  signInFromReferal: 'Log ind med din profil fra henvisende side',
  siteWouldLikeToAccess:
    config.TITLE +
    ' ønsker adgang til følgende oplysninger for at registrere dig på dette sted:',
  permissionsToAccess:
    'Navn, e-mail, fødselsdato, placering og oplysninger om grundlæggende datingprofil',
  iConsentToDetailsAndRegister:
    'Jeg accepterer, at disse oplysninger bruges til at registrere min profil og bekræfter, at jeg accepterer ',
  allow: 'Tillad',
  byClickingAllow:
    'Ved at klikke på TILLAD giver du samtykke til, at disse oplysninger bruges af ' +
    config.TITLE +
    ' at registrere dig på datingwebstedet og bekræfte, at du accepterer nedenstående vilkår og betingelser. Alternativt kan du bruge vores ',
  standardRegistrationForm: 'standard registreringsformular',
  // SpecialOffer2x
  getFreeMembership: 'Få et GRATIS medlemskab på {0}',
  doubleYourChances: 'Doble dine chancer til',
  weHavePartnered:
    'Vi har indgået et samarbejde med {0} for at øge vores medlemmers chancer for at finde et match. Når du klikker på knappen ovenfor, opretter vi automatisk en 100% GRATIS PROFIL på {0} og omdirigerer dig til medlemsområdet, så du kan begynde at søge i deres database efter potentielle kampe.',
  congratulationsYouGotFree:
    'Tillykke, du fik GRATIS medlemskab hos {site_name}.',
  toGetLoggedInto: ' for at blive logget ind på siden.',
  // RefundCreditCard
  refundCreditCard: 'Tilbagebetaling med nyt kreditkort',
  refundCreditCardSuccess: 'Din anmodning om refusion er blevet indsendt.',
  // Nearby Connect
  nearbyConnect: 'Nærliggende Connect',
  nearbyDecline: 'Nej tak, jeg vil ikke sende det nu, jeg gør det senere.',
  introduceMyself: 'Præsentere mig selv',
  distance: 'Afstand',
  message: 'Besked',
  sentByNearbyConnect: 'Sendt af NærliggendeConnect',
  anyDistance: 'Enhver afstand',
  typeYourMessageHere: 'Skriv din besked her',
  sendThisToMyNewMatches:
    'Senden Sie dies auch an alle neuen Spiele, wenn sie beitreten',
  successNearbyConnect: 'Du har konfigureret Nearby Connect',
  nearbyConnectTitle:
    'Kom i kontakt med hundredvis af medlemmer med det samme! Kun brugere, der matcher din profil, vil modtage disse beskeder. Indtast din besked nedenfor for at komme i gang:',
  nearbyConnectAlert:
    'Nearby Connect-beskeder er unikke beskeder fra andre rigtige medlemmer, som kunne være dit perfekte match. Disse beskeder sendes automatisk kun til brugere, der matcher denne brugerprofil',
  nearbyUnavailable:
    'Beklager, NearbyConnect-funktionen er ikke tilgængelig i øjeblikket. Denne funktion kan bruges én gang pr. 30 dage. Tak for din forståelse.',
  nearbyFeatureUsed: 'Du brugte NearbyConnect-funktionen på {date}.',
  toKeepNearbyFree:
    'For at holde NearbyConnect gratis, begrænser vi den til kun én introduktion hver 30. dag(e).',
  ifYouLikeToBeIntroduced:
    'Hvis du gerne vil præsenteres for flere medlemmer, så kom tilbage for {date}.',
  nearbyConnectValentineTitle: 'Valentine Special',
  nearbyConnectValentineText1:
    'Valentinsdag nærmer sig. I en begrænset periode lader vi dig sende en ',
  nearbyConnectValentineText2: 'GRATIS introduktionsbesked ',
  nearbyConnectValentineText3:
    'til hundredvis af brugere, der matcher dine præferencer. Indtast blot din besked nedenfor for at komme i gang:',
  // subscription status
  subscriptionStatus: 'Abonnementsstatus',
  subscritpionStatusManageLink1: 'Tillykke! Du er VIP-medlem. Besøg venligst ',
  subscritpionStatusManageLink2: 'for at administrere dit abonnement.',
  subscriptionUpgradeLink1: 'Du er et grundlæggende medlem. ',
  subscriptionUpgradeLink2: 'Opgrader til VIP nu!',
  // Manage Nearby Connects
  manageNearbyConnects: 'Administrer Nearby Connect',
  sendNewNearbyConnectMessage: 'Send ny NearbyConnect-besked',
  activeUntil: 'Aktiv indtil',
  sendToNewJoins: 'Send til nye tilslutninger',
  update: 'Opdatering',
  disable: 'Deaktiver',
  nearbyConnectUpdated: 'Nearby Connect blev opdateret',
  nearbyConnectWillBeAvailable:
    'Nearby Connect vil være tilgængelig for dig næste gang ',
  canChangeMessageOn: 'Kan ændre besked på',
  getInTouchWith:
    'Kom i kontakt med hundredvis af medlemmer med det samme! Kun brugere, der matcher din profil, vil modtage disse beskeder.',
  // Cookie Consent
  cookieConsentText:
    'Siden bruger cookies. Ved at fortsætte med at navigere på siden accepterer du udtrykkeligt at bruge cookies.',
  cookieConsentDetailsLinkText: 'Detaljer',
  cookieConsentButtonText: 'Jeg forstår',
  cookieConsentDeclineButtonText: 'Tæt',
  cookieTitle: 'Denne side bruger cookies',
  cookieSubTitle:
    'Vi bruger cookies og andre sporingsteknologier til at forbedre din browsingoplevelse på vores websted, for at vise dig personligt indhold og målrettede annoncer, til at analysere vores webstedstrafik og for at forstå, hvor vores besøgende kommer fra.',
  cookieAcceptAllCookies: 'Accepter alle',
  cookieDeclineAllCookies: 'Afvis alle',
  cookieManagePreferences: 'Skift mine præferencer',
  cookieClosePreferences: 'Luk Præferencer',
  cookieNecessaryTitle: 'Nødvendig',
  cookieNecessaryDescription:
    'Disse cookies er vigtige for at give dig tjenester, der er tilgængelige via vores hjemmeside, og for at du kan bruge visse funktioner på vores hjemmeside. Uden disse cookies kan vi ikke tilbyde dig visse tjenester på vores hjemmeside.',
  cookieActiveText: 'Aktiv',
  cookieAlwaysActiveText: 'Altid aktiv',
  cookieInactiveText: 'Inaktiv',
  cookieFunctionallityTitle: 'Funktionalitet',
  cookieFunctionallityDescription:
    'Disse cookies bruges til at give dig en mere personlig oplevelse på vores hjemmeside og til at huske valg, du træffer, når du bruger vores hjemmeside. For eksempel kan vi bruge funktionalitetscookies til at huske dine sprogpræferencer eller huske dine loginoplysninger.',
  cookieAnalyticsTitle: 'Analytics',
  cookieAnalyticsDescription:
    'Disse cookies bruges til at indsamle oplysninger til at analysere trafikken til vores hjemmeside, og hvordan besøgende bruger vores hjemmeside. For eksempel kan disse cookies spore ting, såsom hvor lang tid du bruger på webstedet eller de sider, du besøger, hvilket hjælper os med at forstå, hvordan vi kan forbedre vores websted for dig. De oplysninger, der indsamles gennem disse sporings- og ydeevnecookies, identificerer ikke nogen enkelt besøgende.',
  cookieMarketingTitle: 'Markedsføring',
  cookieMarketingDescription:
    'Disse cookies bruges til at vise annoncer, der sandsynligvis vil være af interesse for dig baseret på dine browservaner. Disse cookies, som serveret af vores indholds- og/eller reklameudbydere, kan kombinere oplysninger, de har indsamlet fra vores websted, med andre oplysninger, de uafhængigt har indsamlet vedrørende din webbrowsers aktiviteter på tværs af deres netværk af websteder. Hvis du vælger at fjerne eller deaktivere disse målretnings- eller annonceringscookies, vil du stadig se annoncer, men de er muligvis ikke relevante for dig.',
  cookieOtherTitle: 'Andet',
  cookieOtherDescription: 'Nogle andre cookies',
  cookieSavePreferences: 'Gem præferencer og luk',
  cookiePreferencesTitle: 'Vælg dine præferencer',
  manageCookies: 'Administrer cookies',
  cookiesViewDetails: 'Se detaljer',
  cookiesProviders: 'Udbydere af cookies',
  cookiesYahoo: 'Used by Yahoo for content and advertising personalisation.',
  cookiesGoogleDetectSpam: 'Used to detect spam, fraud, and abuse.',
  cookiesGoogleAds:
    'Used to personalize Google ads based on recent searches and interactions.',
  years: 'flere år',
  year: 'år',
  cookiesGoogleAdDelivery:
    'Bruges til at levere annoncelevering eller retargeting.',
  cookiesGoogleUseOurSite:
    'Cookie bruges til at indsamle oplysninger om, hvordan besøgende bruger vores websted.',
  cookiesGoogleDistinguishUsers: 'Bruges til at skelne brugere.',
  cookiesGoogleCrossSite:
    'Denne cookie bruges til at forhindre browseren i at sende denne cookie sammen med anmodninger på tværs af websteder.',
  cookiesGoogleUniqueIdTracking:
    'Disse cookies bruger en unik identifikator til sporingsformål.',
  cookiesGoogleProtectData:
    'Sikkerhedscookie for at beskytte en brugers data mod uautoriseret adgang.',
  cookiesGoogleTrackConversions: 'Bruges til at gemme og spore konverteringer.',
  cookiesBingAds:
    'Denne cookie gør det muligt at vise relevante annoncer til besøgende.',
  cookiesBingTracking:
    'Microsoft User Identifier-sporingscookie brugt af Bing Ads.',
  cookiesBingTrackingAdvertising:
    'Dette er en sporingscookie, der bruges af Microsoft Bing-annoncering for at give os mulighed for at interagere med en besøgende, der tidligere har besøgt vores websted.',
  cookiesBingClarityID:
    "Bevarer Clarity-bruger-id'et og præferencer, der er unikke for det websted, tilskrives det samme bruger-id.",
  cookiesBingClarityMultiple:
    'Forbinder flere sidevisninger af en bruger til en enkelt Clarity-sessionsoptagelse.',
  cookiesFacebookTracking:
    'Bruges til at gemme og spore besøg på tværs af websteder.',
  cookiesFacebookUniqueId:
    'Bruges til at gemme en unik identifikator for din browser, der blandt andet hjælper os med at beskytte dig mod svindel.',
  cookiesFacebookDevicePixelRatio:
    'Bruges til at registrere enhedspixelforholdet på din skærm, og om du har aktiveret højkontrasttilstand eller ej, så vi kan gengive vores websteder optimalt.',
  cookiesFacebookMarketing:
    'Bruges til at levere annoncelevering eller retargeting.',
  cookiesGoogleDoubleClick:
    'Bruges af Google DoubleClick til at registrere og rapportere webstedsbrugerens handlinger efter at have set eller klikket på en af ​​annoncørens annoncer med det formål at måle effektiviteten af en annonce og præsentere målrettede annoncer for brugeren.',
  cookiesBingRefreshMuid: 'Angiver, om MUID skal opdateres.',
  cookiesRomanceGuard: 'Bruges til afsløring af bedrageri, spam, malware.',
  cookiesTaboolaUniqueId:
    'Tildeler et unikt, opdelt bruger-id, som Taboola bruger til tilskrivning og rapporteringsformål og til at skræddersy anbefalinger til denne specifikke bruger baseret på interaktioner med én annoncør eller udgiver.',
  cookiesSnapchatId: 'Bruges til at hjælpe med at identificere en besøgende.',
  cookiesSnapchatTrackId:
    'Indstiller et unikt ID for den besøgende, der gør det muligt for tredjepartsannoncører at målrette den besøgende med relevant annonce. Denne parringstjeneste leveres af tredjeparts annoncehubs, som letter budgivning i realtid for annoncører.',
  cookiesSnapchatPixelId:
    'Bruges til at bestemme, om et tredjepartstag vil blive kaldt i en Snap Ads Pixel.',
  cookiesVWOVisits: 'Bruges til at gemme unikke besøg.',
  cookiesVWOTest: 'Bruges til at læse om der kan placeres cookies.',
  cookiesVWOSafari:
    'Denne cookie er en krukke med alle cookies. Den er i øjeblikket kun lavet til Safari-browseren. I fremtiden vil det erstatte alle VWO cookies. BEMÆRK: Det faktiske udløb af denne cookie er irrelevant, da det gemmer udløbet af cookies, der er sat i den, og bliver ved med at udløbe dem.',
  cookiesVWODS:
    'Denne cookie gemmer vedvarende data på besøgsniveau til VWO Insights.',
  cookiesVWOExpiration: 'Afhænger af kontoens opbevaringsperiode.',
  cookiesVWOUniqueId:
    'Denne cookie genererer et unikt ID for hver besøgende og bruges til rapportsegmenteringsfunktionen i VWO. Det giver også mulighed for at se data på en mere raffineret måde.',
  cookiesVWOUniqueVisits:
    'Denne cookie beregner unikke besøgendes trafik på et websted.',
  cookiesAppsFlyer:
    'Vi bruger denne service til at registrere brugernes enheder såsom iOS iPhone eller Android Phone for at vise bannere til brugerne for at fortælle dem, om de ønsker at installere en indbygget applikation fra iStore eller Google Play Butik.',
  cookiesTikTok:
    'For at måle og forbedre effektiviteten af ​​dine reklamekampagner og for at personliggøre brugerens oplevelse (inklusive annoncer) på TikTok.',
  cookiesRaygun:
    'Raygun leverer fejl-, nedbruds- og ydeevneovervågning til softwareteams.',
  name: 'Navn',
  description: 'Beskrivelse',
  duration: 'Varighed',
  url: 'URL',
  domain: 'Domæne',

  // email verification
  welcome: 'Velkommen',
  emailConfirmationTitle: 'Bekræft din e-mail for at holde kontakten!',
  emailConfirmationDesc:
    'Din e-mail er endnu ikke bekræftet, så du modtager ikke nogen e-mails eller beskeder!',
  weRecomend:
    'Vi anbefaler, at du klikker på knappen for at gensende linket, og derefter tjekker din e-mail.',
  resendConfirmation: 'SEND BEKRÆFTELSESMAIL IGEN',
  ifForAnyReason:
    'Hvis du af en eller anden grund ønsker at ændre din e-mailadresse, ',
  dontSeeIt: 'Kan du ikke se det?',
  andWeWillResend:
    'og vi sender e-mailen igen med det samme, så den er nem at finde!',
  checkSpamFolder: 'Tjek spam-mappen',
  ifYouDoNotSeeYourMessage:
    'Hvis du ikke kan se din besked i indbakken, skal du tjekke spam-mappen.',
  thenSelect: 'Vælg derefter beskeden og marker den som IKKE SPAM.',
  needHelp: 'Brug for hjælp? ',
  ClickHereForMoreInfo: 'Klik her for mere info',
  addUsToYouContacts: 'Føj os til din kontaktliste',
  beSureToAdd: 'Sørg for at tilføje',
  notifyEmail: 'notify@nearbynotifications.com',
  toYourAddressBook:
    'til din adressebog/kontaktliste, så dine beskeder og flirts kommer til din indbakke.',
  copiedToClipboard: 'Kopieret til udklipsholder',
  cantWait:
    'Vi kan ikke vente med at hjælpe dig med at finde din perfekte partner. Vi har tusinder af medlemmer, der venter på at møde dig...',
  seeYou: 'Vi ses indenfor!',
  emailConfirmationDecline:
    'Nej tak, jeg vil ikke sende det nu, jeg gør det senere.',
  emailConfirmationToast:
    'Bekræftelseslink sendt med succes. Tjek venligst din e-mail.',

  // addUsToContactsInfo
  addUsToYouContactsList:
    'Tilføj ' +
    config.DOMAIN.replace(/https?:\/\//, '').toUpperCase() +
    ' til din kontaktliste for at undgå ',
  missingAnyMessage: 'AT MANGLENDE nogen beskeder!',
  contactsInfoDetails:
    'Tilføj ' +
    config.DOMAIN.replace(/https?:\/\//, '').toUpperCase() +
    ' til din adressebog eller kontaktliste, så du ikke går glip af nogen beskeder eller flirtationer.',
  openMessageStep:
    'Åbn en besked fra afsenderen, du vil gemme som kontakt i Gmail.',
  hoverCursorStep: 'Hold markøren over afsenderens navn øverst i e-mailen.',
  selectAddToContactsStep: 'Vælg Tilføj til kontakter i pop-up-menuen.',
  resendConfirmationLinkText: 'Klik her for at gensende din bekræftelseslink',
  toMakeItEasier: 'så det bliver nemmere at finde i din postkasse!',
  checkGmailInbox: 'TJEK DIN GMAIL INDBAKKE',

  // checkSpamFolder
  beSure: 'Sørg for at tjekke',
  spamFolder: 'Spam-mappen',
  ifYouDoNotSeeMessage: 'hvis du ikke ser vores besked i indbakken!',
  spamFolderDetails:
    'Hvis du finder vores besked fejlagtigt klassificeret som spam, kan du fjerne markeringen af beskeden.',
  unmarkingAMessage:
    'Fjernelse af markeringen af en besked flytter den automatisk til din indbakke.',
  openSpamFolderStep: 'Klik på Spam i venstre side af enhver side.',
  selectMessageStep: 'Vælg beskeden.',
  markAsNotSpamStep: "Klik på 'Ikke spam' øverst på siden.",

  // change email
  changeEmail: 'Skift e-mail!',
  newEmailAddress: 'Ny e-mailadresse',
  currentEmailAddress: 'Nuværende e-mailadresse',
};



// WEBPACK FOOTER //
// ./src/assets/localization/da.js